class Auth{
  
    login(cb){
        this.authenticated=true;
        cb()
    }
    logout(cb){
        this.authenticated=false;
        cb()
    }

    isAuthenticated(){
        return localStorage.getItem('log');
                
    }


}
export default new Auth()